<template>
  <div class="homework-statis">
    <homework-statis-head :hw-id="hw_id" :class-id="class_id"></homework-statis-head>
    <div class="statis-wrapper">
      <div class="title">作业详情</div>
      <div class="section-content">
        <Tabs
          :value="curHomeworkTab"
          :animated="false"
          class="tab-statis"
          @on-click="onHomeworkTabClick"
        >
          <TabPane label="试题信息统计" name="0">
            <div class="homework-count-box">
              <i class="el-icon-info"></i>
              <span>该部分有</span>
              <span class="num space">{{getQuesCount(-1)}}</span>
              <span>道题，其中{{getQuesCount(1)}}道单选题、{{getQuesCount(2)}}道判断题、{{getQuesCount(3)}}道多选题、{{getQuesCount(5)}}道简答题，总分为</span>
              <span class="num space">{{getQuesScore(-1)}}</span>
              <span>分</span>
            </div>
            <Table class="table-ques" border :columns="tableColumns" :data="tableQuesData">
              <template slot="action">
                <Button type="text" size="small" @click="refresh">刷新</Button>
              </template>
            </Table>
          </TabPane>
          <TabPane label="试题正确率统计" name="1">
            <div class="correct-head">
              <RadioGroup v-model="curCorrectTab" @on-change="onCorrectTagChange">
                <Radio label="0">单题正确率统计</Radio>
                <Radio label="1">题型正确率统计</Radio>
              </RadioGroup>
              <div>
                <span>提交时间：</span>
                <DatePicker
                  type="date"
                  v-model="statisDate"
                  placeholder="请选择提交时间"
                  clearable
                  @on-change="onStatisDateChange"
                  style="width: 200px"
                ></DatePicker>
              </div>
            </div>
            <div class="echarts-wrapper">
              <div ref="correctECharts" class="correct-echarts"></div>
              <p class="echarts-y-note">正确率（%）</p>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <Tabs value="0">
        <TabPane label="作业学员列表" name="0">
          <div class="section-content">
            <Form ref="search" :model="hwDetailForm" inline :label-width="90">
              <FormItem label="学员名称：">
                <Input
                  v-model="hwDetailForm.nickname"
                  placeholder="请输入学员姓名关键字"
                  style="width:200px;"
                  clearable
                ></Input>
              </FormItem>
              <FormItem label="状态：">
                <Select
                  v-model="hwDetailForm.report_status"
                  placeholder="请选择"
                  style="width:200px;"
                  clearable
                >
                  <Option
                    v-for="(item, index) in approvedStatusDict"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  ></Option>
                </Select>
              </FormItem>
              <Form-item label="提交时间">
                <Date-picker
                  :editable="false"
                  ref="formDate"
                  type="datetimerange"
                  placeholder="开始时间 — 截止时间"
                  style="width:280px;"
                  @on-change="onDateRange"
                  @keydown.native.prevent.enter="onSearch"
                  clearable
                ></Date-picker>
              </Form-item>
              <FormItem class="search-form-btns">
                <div class="btn-wrap form-item-search">
                  <Button icon="ios-search" @click="onSearch">搜索</Button>
                  <Button icon="md-undo" @click="onReset">重置</Button>
                </div>
              </FormItem>
            </Form>
            <Table :columns="tableHwDetailColumns" :data="tableHwDetailData" border>
              <template slot-scope="{row}" slot="c1">
                <span style="margin-right:10px;">{{row.objective_amount}}客观题</span>
                <span>{{row.subjective_amount}}主观题</span>
              </template>
              <template slot-scope="{row}" slot="c2">
                <span style="margin-right:10px;">{{row.actual_objective_amount}}客观题</span>
                <span>{{row.actual_subjective_amount}}主观题</span>
              </template>
              <template slot-scope="{row}" slot="action">
                <Button
                  type="text"
                  size="small"
                  :to="{name:'HomeworkStatisPreview', query:{id: $route.query.id||$route.query.hw_id}}"
                  v-if="row.status==1"
                >预览</Button>
                <Button
                  type="text"
                  size="small"
                  :to="{name:'HomeworkApprove', query:{student_id: row.uid,reportId:row.report_id}}"
                  v-if="row.status!=1"
                >详情</Button>
                <span v-if="row.status==3">-</span>
                <Button
                  type="text"
                  size="small"
                  :to="{name:'HomeworkStatisAnswer', query:{hwId: $route.query.id||$route.query.hw_id,reportId:row.report_id}}"
                  v-if="row.status==3"
                >答题统计</Button>
              </template>
            </Table>
          </div>
          <Page
            background
            @on-change="onCurrentPageChange"
            :current="page"
            :page-size="limit"
            :total="total"
          ></Page>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import HomeworkStatisHead from "@/components/Homework/HomeworkStatisHead";
import ECharts from "echarts";
export default {
  name: "HomeworkStatis",
  components: {
    HomeworkStatisHead
  },
  data() {
    return {
      hw_id: this.$route.query.hw_id,
      class_id: this.$route.query.class_id,
      curHomeworkTab: "0",
      curCorrectTab: "0",
      tableColumns: [
        {
          title: "题型",
          key: "name",
          align: "center"
        },
        {
          title: "题目数",
          key: "total",
          align: "center"
        },
        {
          title: "总分值",
          key: "total_score",
          align: "center"
        },
        {
          title: "正确率",
          key: "correct_rate",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      tableQuesData: [
        {
          name: "单选题",
          ques_type: 1,
          total: 0,
          total_score: 0,
          correct_rate: "0%"
        },
        {
          name: "多选题",
          ques_type: 2,
          total: 0,
          total_score: 0,
          correct_rate: "0%"
        },
        {
          name: "判断题",
          ques_type: 3,
          total: 0,
          total_score: 0,
          correct_rate: "0%"
        },
        {
          name: "简答题",
          ques_type: 5,
          total: 0,
          total_score: 0,
          correct_rate: "0%"
        }
      ],
      myECharts: null,
      statisDate: "",
      hwDetailForm: {
        nickname: "",
        mobile: "",
        report_status: "",
        start_at: "",
        end_at: ""
      },
      approvedStatusDict: [
        { key: 1, value: "已交", class: "toread" },
        { key: 2, value: "未交", class: "completed" }
      ],
      tableHwDetailColumns: [
        {
          title: "学员名称",
          key: "nickname"
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center"
        },
        {
          title: "作业所属课时",
          key: "course_periods_title",
          align: "center"
        },
        {
          title: "作业状态",
          key: "status_name",
          align: "center"
        },
        {
          title: "批阅状态",
          key: "review_status_name",
          align: "center"
        },
        {
          title: "题目总数",
          slot: "c1"
        },
        {
          title: "实交题目数",
          slot: "c2"
        },
        {
          title: "最新提交时间",
          key: "updated_at_time",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      tableHwDetailData: [],
      approveStatus: {
        1: "--",
        2: "待批阅",
        3: "已批阅"
      },
      page: 1,
      total: 0,
      limit: 10
    };
  },
  async created() {
    await this.requestQuesData();
    await this.requestHomeworkDetail();
  },
  mounted() {
    this.initECharts();
  },
  methods: {
    async refresh() {
      await this.requestQuesData();
    },
    onDateRange(range) {
      this.hwDetailForm.start_at = range[0];
      this.hwDetailForm.end_at = range[1];
    },
    async onHomeworkTabClick(tab) {
      if (tab == 1) {
        // 这里resize一下ECharts，防止宽度为0，导致ECharts显示不出的问题
        if (this.myECharts.getWidth() == 0) {
          await this.$nextTick();
          this.myECharts.resize();
        }
        this.onCorrectTagChange(this.curCorrectTab);
      }
    },
    onStatisDateChange() {
      this.onCorrectTagChange(this.curCorrectTab);
    },
    async onCorrectTagChange(label) {
      this.setECharts([], []);
      if (label == 0) {
        await this.requestQuesNumberStatisData();
      } else if (label == 1) {
        await this.requestQuesTypeStatisData();
      }
    },
    onSearch() {
      this.page = 1;
      this.requestHomeworkDetail();
    },
    onReset() {
      this.$refs.formDate.handleClear();
      this.hwDetailForm.nickname = "";
      this.hwDetailForm.mobile = "";
      this.hwDetailForm.report_status = "";
      this.hwDetailForm.start_at = "";
      this.hwDetailForm.end_at = "";
      this.onSearch();
    },
    onCurrentPageChange(val) {
      this.page = val;
      this.requestHomeworkDetail();
    },
    onApproved(row) {
      this.$router.push({
        name: "HomeworkApprove",
        query: {
          report_id: row.report_id
        }
      });
    },
    onWatch(row) {
      this.$router.push({
        name: "HomeworkApproveView",
        query: {
          report_id: row.report_id
        }
      });
    },
    // other
    initECharts() {
      this.myECharts = ECharts.init(this.$refs.correctECharts);
      this.myECharts.setOption({
        color: ["#1890FF"],
        grid: {
          left: 30,
          right: 30,
          bottom: 30
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value",
          interval: 20,
          min: 0,
          max: 100
        },
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 28,
            label: {
              show: true,
              position: "top",
              fontSize: 10,
              formatter: function(params) {
                return params.data + "%";
              }
            }
          }
        ]
      });
    },
    // 设置图表 xAxisLabel: x轴标签数组    xAxisData: x轴数据数组
    setECharts(xAxisLabel, xAxisData) {
      if (!this.myECharts) return;
      this.myECharts.setOption({
        xAxis: {
          data: xAxisLabel
        },
        series: [
          {
            data: xAxisData
          }
        ]
      });
    },
    // 获取题型数量，quesType传-1表示全部
    getQuesCount(quesType) {
      let ret = 0;
      this.tableQuesData.forEach(i => {
        if (quesType == -1 || quesType == i.ques_type) {
          ret += i.total;
        }
      });
      return ret;
    },
    // 获取题型分数，quesType传-1表示全部
    getQuesScore(quesType) {
      let ret = 0;
      this.tableQuesData.forEach(i => {
        if (quesType == -1 || quesType == i.ques_type) {
          ret += +i.total_score;
        }
      });
      return ret;
    },
    getApprovedStatus(status) {
      for (const i of this.approvedStatusDict) {
        if (i.key == status) {
          return i.value;
        }
      }
      return "";
    },
    getApprovedStatusClass(status) {
      for (const i of this.approvedStatusDict) {
        if (i.key == status) {
          return i.class;
        }
      }
      return "";
    },
    // request
    // 作业信息
    // 题型信息
    async requestQuesData() {
      let data = await this.$http.get(
        `/api/homework/questionsType/${this.hw_id}`,
        { class_id: this.class_id }
      );
      let dataStatis = await this.$http.get(
        `/api/homework/questionsTypeStatistics/${this.hw_id}`,
        {
          start_at: this.statisDate || "",
          class_id: this.class_id
        }
      );
      data.forEach(i => {
        this.tableQuesData.forEach(ci => {
          if (i.ques_type == ci.ques_type) {
            ci.total = i.total;
            ci.total_score = i.total_score;
          }
        });
      });
      dataStatis.forEach(i => {
        this.tableQuesData.forEach(ci => {
          if (i.type == ci.ques_type) {
            ci.correct_rate = parseInt(i.correct_rate * 100) + "%";
          }
        });
      });
    },
    // 学员作业详情
    async requestHomeworkDetail() {
      let data = await this.$http.get(
        `/api/homework/students/list/${this.hw_id}`,
        {
          ...this.hwDetailForm,
          page: this.page,
          limit: this.limit,
          class_id: this.class_id
        }
      );
      data.list.forEach(s => {
        s.updated_at_time = new Date(parseInt(s.updated_at) * 1000).format(
          "yyyy-MM-dd hh:mm"
        );
        s.status_name = s.status == 1 ? "未交" : "已交";
        s.review_status_name = this.approveStatus[s.status];

        let list = [];
        if (s.title) {
          list.push(s.title);
        }
        if (s.periods_title) {
          list.push(s.periods_title);
        }
        s.course_periods_title = list.join("/");
      });
      this.tableHwDetailData = data.list;
      this.total = data.total;
    },
    // 题型正确率统计
    async requestQuesTypeStatisData() {
      let data = await this.$http.get(
        `/api/homework/questionsTypeStatistics/${this.hw_id}`,
        {
          start_at: this.statisDate || "",
          class_id: this.class_id
        }
      );
      const echartsLabels = ["单选题", "多选题", "判断题", "连线题", "简答题"],
        echartsDatas = [0, 0, 0, 0, 0];
      data.forEach(i => {
        // 题型刚好和索引是-1关系
        echartsDatas[i.type - 1] = (i.correct_rate * 100).toFixed(0);
      });
      this.setECharts(echartsLabels, echartsDatas);
    },
    // 单题正确率统计
    async requestQuesNumberStatisData() {
      let data = await this.$http.get(
        `/api/homework/perQuestion/${this.hw_id}`,
        {
          start_at: this.statisDate || "",
          class_id: this.class_id
        }
      );
      const echartsLabels = [],
        echartsDatas = [];
      data.forEach((i, index) => {
        echartsLabels.push(`第${index + 1}题`);
        echartsDatas.push((i.correct_rate * 100).toFixed(0));
      });
      this.setECharts(echartsLabels, echartsDatas);
    }
  }
};
</script>

<style lang="scss" scoped>
.homework-statis {
  .statis-wrapper {
    background-color: #fff;
    margin-top: 30px;
    /deep/ {
      .ivu-page {
        text-align: right;
      }
    }
    .section-content {
      padding: 10px 0 20px 0;
    }
    .correct-head {
      display: flex;
      justify-content: space-between;
    }
    .echarts-wrapper {
      position: relative;
      .correct-echarts {
        height: 400px;
      }
      .echarts-y-note {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        position: absolute;
        top: 20px;
        left: 0;
      }
    }
    .table-detail {
      .toread {
        color: #ee1f1f;
      }
      .completed {
        color: #30b5a6;
      }
    }
  }
}
.num {
  color: #4169ff;
  font-weight: 500;
}
.num-red {
  color: #ee1f1f;
  font-weight: 500;
}
.space {
  margin: 0 5px;
}
.el-table {
  // &.table-ques /deep/ td {
  //   padding: 4px 0;
  // }
  &.table-detail /deep/ td {
    padding: 4px 0;
  }
}
</style>
